module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recipeImage":"An image of the dish","addPhoto":"Add photo"},"de":{"recipeImage":"Ein Bild des Rezepts","addPhoto":"Foto hinzufügen"}}')
  delete Component.options._Ctor
}
